'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';
import { io, Socket } from 'socket.io-client';
import { useAuth } from './AuthContext';

interface SocketContextType {
  socket: Socket | null;
  isConnected: boolean;
}

const SocketContext = createContext<SocketContextType>({
  socket: null,
  isConnected: false,
});

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [isConnected, setIsConnected] = useState(false);
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    // Temporarily disabled Socket.IO to prevent connection errors
    // TODO: Re-implement Socket.IO with proper App Router support
    
    // if (isAuthenticated && user) {
    //   const newSocket = io(process.env.NODE_ENV === 'production' 
    //     ? process.env.NEXT_PUBLIC_SOCKET_URL || 'https://your-domain.com'
    //     : 'http://localhost:3000', {
    //     path: '/api/socketio',
    //     autoConnect: true,
    //   });

    //   newSocket.on('connect', () => {
    //     console.log('Connected to socket server');
    //     setIsConnected(true);
    //     newSocket.emit('join-user', user.id);
    //     newSocket.emit('user-online', { userId: user.id, username: user.username });
    //   });

    //   newSocket.on('disconnect', () => {
    //     console.log('Disconnected from socket server');
    //     setIsConnected(false);
    //     newSocket.emit('user-offline', { userId: user.id });
    //   });

    //   setSocket(newSocket);

    //   return () => {
    //     newSocket.close();
    //   };
    // }
  }, [isAuthenticated, user]);

  return (
    <SocketContext.Provider value={{ socket, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};
